import { useId, type ReactNode } from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/ui/base/alert';
import { Badge } from '@/ui/base/badge';
import { Button } from '@/ui/base/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/ui/base/card';
import { Input } from '@/ui/base/input';
import { Label } from '@/ui/base/label';

/**
 * Componentes reais dentro de um invólucro `.dark`: o seletor de classe do
 * tema escuro vale para a subárvore, então os tokens resolvem como no escuro.
 */
export function ComponentesNoTemaEscuro() {
  const campo = useId();
  return (
    <div className="mb-2">
      <h3 className="text-base font-bold text-foreground">Componentes no tema escuro</h3>
      <p className="text-xs text-muted-foreground mt-0.5 mb-3">
        Os mesmos componentes da interface, renderizados dentro de um trecho com a classe dark: as
        cores saem dos tokens do bloco .dark, sem nenhuma cor própria.
      </p>
      <div
        className="dark rounded-lg border border-border bg-background text-foreground p-5 space-y-5"
        data-print-keep-bg=""
      >
        <Linha titulo="Botões">
          <Button>Confirmar</Button>
          <Button variant="secondary">Secundário</Button>
          <Button variant="outline">Contorno</Button>
          <Button variant="destructive">Excluir</Button>
          <Button variant="link">Ligação</Button>
        </Linha>
        <Linha titulo="Selos">
          <Badge>Padrão</Badge>
          <Badge variant="secondary">Secundário</Badge>
          <Badge variant="destructive">Destrutivo</Badge>
          <Badge variant="outline">Contorno</Badge>
        </Linha>
        <div className="grid grid-cols-2 gap-4">
          <Card>
            <CardHeader>
              <CardTitle>Cartão</CardTitle>
              <CardDescription>Superfície --card com texto --card-foreground.</CardDescription>
            </CardHeader>
            <CardContent className="space-y-2">
              <Label htmlFor={campo}>Campo de texto</Label>
              <Input id={campo} readOnly value="Valor preenchido" />
            </CardContent>
          </Card>
          <div className="space-y-3">
            <Alert role="note">
              <AlertTitle>Aviso</AlertTitle>
              <AlertDescription>Texto de apoio sobre o fundo da página.</AlertDescription>
            </Alert>
            <Alert role="note" variant="destructive">
              <AlertTitle>Erro</AlertTitle>
              <AlertDescription>Mensagem que diz o que fazer.</AlertDescription>
            </Alert>
          </div>
        </div>
      </div>
    </div>
  );
}

function Linha({ titulo, children }: { titulo: string; children: ReactNode }) {
  return (
    <div>
      <p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground mb-2">
        {titulo}
      </p>
      <div className="flex flex-wrap items-center gap-3">{children}</div>
    </div>
  );
}
